import { createBaseApi } from 'store/api';

export const apiConfig = {
  local: 'https://strapi.sb.evoent.tech/',
  stage: 'https://strapi.sb.evoent.tech/',
  prod: 'https://strapi.evoent.tech/',
};

// we will use this token for all envs
const accessToken =
  '2588e60a2ea27b0cd5716111674f6ed89d9e61e55e09570adf024199159a8e23667b9fd63a2ef79658b65496018a100a258bd8c119e39b1eccdb67061660a707604c76ba586a9d9e94749695f0b45c987f19544dd653f6942a1cf1c125629909456781120f20cecb892ddc06072368ba27d558b14617343d9fcfc34bb9507c0a';

export const api = createBaseApi({
  apiConfig,
  accessToken,
  reducerPath: 'strapiService',
  tagTypes: ['RSUsers'],
});
